export default function Hero() {
  const scrollToContact = () => {
    try {
      if (window.location.pathname !== "/") {
        window.location.assign("/");
        setTimeout(() => {
          const contactSection = document.getElementById("contact");
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      } else {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (err) {
      console.error("Hero.scrollToContact: unexpected error", err);
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://ik.imagekit.io/pianomoverslondon/tr:w-1200,h-800,c-at_max,q-85,f-webp/Piano%20Movers%20Gallery%20London%20Jobs/Piano_Movers_London_Pictures_from_job%20(1).jpeg"
          alt="Piano movers London — team carrying grand piano"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-serif font-bold mb-6">
          Piano Movers London
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-white/90 font-light">
          Expert piano moving specialists — London&apos;s most experienced piano moving service
        </p>
        <button
          onClick={scrollToContact}
          className="bg-[#c9a84c] hover:bg-[#b8973d] text-[#0e0d0b] px-8 py-4 rounded-md text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
        >
          Request a Quote
        </button>
      </div>
    </section>
  );
}